import axios from 'axios';
import { format } from 'date-fns';
import React from 'react';
import AxiosPromotion from '.';
import config from '../../config';
import { getAccessToken } from './auth.service';
import { commonConstant } from '../../common';
import { getDataFromSession, thaiDate } from '../../utill.func';
import { SESSION_KEY } from '../../common/commonConstant';

export const RULE_BASED = 'RULE_BASED';
export const SOP_BEYOND = 'BEYOND';
export const SOP_BASIC = 'BASIC';

const DELIVERYMODE = {
  HOME: 'HOMEDELIVERY',
};

export const PAYMENT_OPTION = {
  PIF: 'PIF',
  ZIPP: 'ZIPP',
  ZIPP_ABO: 'ZIPP_ABO',
};

export const INSTALLMENT_TYPE = {
  TRUE: 'TRUE',
  FALSE: 'FALSE',
};

export const SMART_REPORT_TASK = {
  VIEW: 'view',
  DOWNLOAD: 'download',
};

export const STOCK_STATUS = {
  inStock: 'inStock',
  backOrder: 'backOrder',
  outOfStock: 'outOfStock',
  notYetAvailable: 'notYetAvailable',
  noLongerAvailable: 'noLongerAvailable',
  temporaryNotAvailable: 'temporaryNotAvailable',
  notAvailableAtWarehouse: 'notAvailableAtWarehouse',
};

export const API_STOCK_STATUS = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
};

export const STOCK_STATUS_MESSAGE = {
  outOfStock: 'สินค้าหมด',
  backOrder: 'ค้างส่ง',
  notYetAvailable: 'เร็วๆ นี้',
  noLongerAvailable: 'เลิกจำหน่าย',
  temporaryNotAvailable: 'หมดชั่วคราว',
  notAvailableAtWarehouse: 'ไม่มีสินค้าที่สาขานี',
};

export const BACKORDER_MESSAGE = {
  availableSoon: 'พร้อมจำหน่ายเร็วๆ นี้',
}

export const message = {
  error: {
    cart: 'ไม่พบข้อมูลตะกร้าสินค้า',
    somethingWrong: 'ขออภัยเกิดข้อผิดพลาดบางอย่าง กรุณาลองใหม่อีกครั้ง',
    alreadyAddress: 'คุณมีข้อมูลที่อยู่นี้อยู่แล้ว กรุณากรอกข้อมูลใหม่อีกครั้ง',
    phoneNotFound: 'กรุณากรอกเบอร์โทรศัพท์',
    order: 'ขออภัยสินค้าภายในตะกร้าไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
    notFound: 'ขออภัยคะ ไม่พบข้อมูลนี้',
  },
};

export const PAYMENT_TYPE = {
  PIF: 'ชำระเต็มจำนวน',
  ZIPP: 'ผ่อนชำระ'
}

export const isCartABOMemberType = (accountType) => {
  const isABOMember =
    (accountType?.toLowerCase() === 'abo' || accountType?.toLowerCase() === 'business_owner') ||
    accountType?.toLowerCase() === 'member';
  return isABOMember;
};

export const isCartABOType = (accountType) => {
  return accountType?.toLowerCase() === 'abo' || accountType?.toLowerCase() === 'business_owner';
};

export const isCartMemberType = (accountType) => {
  return accountType?.toLowerCase() === 'member';
};

export const isNotValidSessionABOMember = (facadeToken, customer) => {
  return (
    !facadeToken ||
    facadeToken.account.accountType.toLowerCase() !==
    customer.type.toLowerCase()
  );
};

export const getPriceFormat = (priceString) => {
  if (('' + priceString).includes('฿')) {
    const priceArr = priceString.split('.');
    if (priceArr.length > 1 && priceArr[1] > 0) {
      return priceString.replace(/฿/, '');
    }
    return priceArr[0].replace(/฿/, '');
  }
  return isNaN(priceString) ? 0 : parseInt(parseFloat(priceString).toFixed()).toLocaleString();
};

export const getPriceWithoutCurrency = priceString => {
  if (('' + priceString).includes('฿')) {
    const priceArr = priceString.split('.');
    if (priceArr.length > 1 && priceArr[1] > 0) {
      return +priceString.replace(/฿/, '');
    }
    return +priceArr[0].replace(/฿/, '');
  }
  return isNaN(priceString) ? 0 : +priceString;
};

export const getDateFormat = (date) => {
  return format(new Date(date), 'dd/MM/yy');
};

export const getTimeFormat = (date) => {
  return format(new Date(date), 'HH:mm');
};

export const getPhoneFormat = (phone) => {
  const phone1 = phone.substring(0, 3).concat('-');
  const phone2 = phone.substring(3, 6).concat('-');
  const phone3 = phone.substring(6, 12);
  return phone1 + phone2 + phone3;
};

export const getFacadeToken = async () => {
  const facadeToken = sessionStorage.getItem('facadeToken');
  return facadeToken && facadeToken !== 'undefined'
    ? JSON.parse(facadeToken)
    : null;
};

export const setFacadeToken = async (accessToken) => {
  return sessionStorage.setItem('facadeToken', JSON.stringify(accessToken));
};

export const clearFacadeToken = () => {
  sessionStorage.removeItem('facadeToken');
};

export const setLocalStorage = (tokenName, value) => {
  return localStorage.setItem(tokenName, value);
};

export const getLocalStorage = async (tokenName) => {
  return localStorage.getItem(tokenName);
};

export const removeLocalStorage = async (tokenName) => {
  return localStorage.removeItem(tokenName);
};

export const convertBlobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
};

export const displayStockLevelStatus = (stock) => {
  if (stock?.stockLevelStatus === STOCK_STATUS.inStock || !stock?.stockLevelStatus) {
    return <></>;
  }
  const baseTag = STOCK_STATUS_MESSAGE[stock?.stockLevelStatus] || '';
  let stockMessage = baseTag;

  if (stock?.deliveryDate) {
    const deliveryDate = stock.deliveryDate;
    let newDateTime;
    if (deliveryDate.includes('T') && deliveryDate.includes('+')) {
      newDateTime = deliveryDate;
    } else {
      const [day, month, year] = deliveryDate.split('/');
      newDateTime = `${year}-${month}-${day}`;
    }
    stockMessage += `: ${thaiDate(newDateTime, 'dd MMM yyyy')}`;
  } else {
    if (stock?.stockLevelStatus === STOCK_STATUS.backOrder) {
      stockMessage += `: ${BACKORDER_MESSAGE.availableSoon}`;
    }
  }
  return (
    <div className={stock?.stockLevelStatus}>{stockMessage}</div>
  );
};

export const getPromotionList = async (id) => {
  const response = await axios.post(
    `${config.API_URL}/promotion/promotionList`,
    {
      userId: id,
      currentPage: '1',
    },
  );
  return response.data.data;
};

export const getPromotionById = async (id) => {
  const response = await AxiosPromotion.get(
    `${config.API_URL}/promotion/detail/${id}`,
  );
  return response.data.data;
};

export const getPublicPromotionById = async (id) => {
  const response = await axios.get(
    `${config.API_URL}/promotion/detail/${id}/public`,
  );
  return response.data.data;
};

export const getCart = async (params) => {
  const customer = getDataFromSession('customer');
  if (customer && customer?.type?.toLowerCase() === 'public') {
    return;
  };
  const response = await AxiosPromotion.get(
    `${config.API_URL}/promotion/cart`,
    {
      params
    },
  );
  return response.data.data;
};

export const createCartPublic = async () => {
  const customer = getDataFromSession('customer');
  if (customer && customer?.type?.toLowerCase() === 'public') {
    return;
  };
  const response = await axios.get(`${config.API_URL}/promotion/cart/public`,
    { headers: { 'Authorization': commonConstant.dummyToken } }
  );
  return response.data.data;
};

export const getCartPublic = async (guid) => {
  const customer = sessionStorage.getItem('customer');
  if (customer && customer.type === 'public') {
    return;
  };
  const response = await axios.get(
    `${config.API_URL}/promotion/cart/public/${guid}`,
    { headers: { 'Authorization': commonConstant.dummyToken } }
  );
  return response.data.data;
};

export const getCartInstallment = async (cartId) => {
  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/installment`,
    { cartId }
  );
  return response.data.data;
};

export const addProductsToCart = async (cartId, products) => {
  const customer = getDataFromSession('customer');
  if (customer && customer?.type?.toLowerCase() === 'public') {
    return;
  };
  const orderEntries = [];
  for (const product of products) {
    if ((product.quantity !== 0 && !isNaN(product.quantity)) && product.kitEntries.length !== 0) {
      const data = {
        product: {
          id: product.id,
        },
        quantity: product.quantity,
        alias: product.id,
      };
      orderEntries.push(data);
      for (const kitEntry of product.kitEntries) {
        if (kitEntry.product.baseOptions.length !== 0) {
          const baseOptions = kitEntry.product.baseOptions[0];
          for (const option of baseOptions.options) {
            if (option.quantity !== 0 && !isNaN(option.quantity)) {
              const data = {
                product: {
                  id: option.id,
                },
                quantity: option.quantity,
                kitEntryCode: kitEntry.kitEntryCode,
              };
              orderEntries.push(data);
            }
          }
        } else {
          const data = {
            product: {
              id: kitEntry.product.id,
            },
            quantity: kitEntry.configuredQty,
            kitEntryCode: kitEntry.kitEntryCode,
          };
          orderEntries.push(data);
        }
      }
    } else {
      if (product.quantity !== 0 && !isNaN(product.quantity)) {
        const data = {
          product: {
            id: product.id,
          },
          quantity: product.quantity,
          // alias: product.id,
          // kitEntryCode: null,
          // isSelect: false,
          // hasSopEntries: false,
          // isGiveAway: false,
        };
        orderEntries.push(data);
      }
    }
  }

  if (orderEntries.length === 0) {
    return { error: [{ th_message: 'กรุณาเลือกสินค้าอย่างน้อย 1 ชิ้น' }] };
  }

  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/item`,
    { cartId, orderEntries },
  );
  return response.data;
};

export const addProductsToCartPublic = async (cartId, products, guid) => {
  const customer = getDataFromSession('customer');
  if (customer && customer?.type?.toLowerCase() === 'public') {
    return;
  };
  const orderEntries = [];
  for (const product of products) {
    if (product.quantity !== 0 && !isNaN(product.quantity) && product.kitEntries.length !== 0) {
      const data = {
        product: {
          id: product.id,
        },
        quantity: product.quantity,
        alias: product.id,
      };
      orderEntries.push(data);
      for (const kitEntry of product.kitEntries) {
        if (kitEntry.product.baseOptions.length !== 0) {
          const baseOptions = kitEntry.product.baseOptions[0];
          for (const option of baseOptions.options) {
            if (option.quantity !== 0 && !isNaN(option.quantity)) {
              const data = {
                product: {
                  id: option.id,
                },
                quantity: option.quantity,
                kitEntryCode: kitEntry.kitEntryCode,
              };
              orderEntries.push(data);
            }
          }
        } else {
          const data = {
            product: {
              id: kitEntry.product.id,
            },
            quantity: kitEntry.configuredQty,
            kitEntryCode: kitEntry.kitEntryCode,
          };
          orderEntries.push(data);
        }
      }
    } else {
      if (product.quantity !== 0 && !isNaN(product.quantity)) {
        const data = {
          product: {
            id: product.id,
          },
          quantity: product.quantity,
        };
        orderEntries.push(data);
      }
    }
  }

  if (orderEntries.length === 0) {
    return { error: [{ th_message: 'กรุณาเลือกสินค้าอย่างน้อย 1 ชิ้น' }] };
  }

  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/item/public/${guid}`,
    { cartId, orderEntries },
  );
  return response.data;
};

export const addPremiumItemToCart = async (
  cartId,
  premiumItem,
  elligibleTargetQty,
  partnerPromotionId = undefined
) => {
  console.log('elligibleTargetQty', elligibleTargetQty);
  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/item`,
    {
      cartId,
      orderEntries: [
        {
          product: {
            id: premiumItem.id,
          },
          quantity: elligibleTargetQty,
          partnerPromotionId
        }
      ],
    },
  );
  return response.data.data;
};

export const createCartInstallment = async (uid, buyNow = true) => {
  const body = {
    uid,
    buyNow,
  };
  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart`,
    body,
  );
  return response.data.data;
};

export const addProductsInstallmentToCart = async (
  cartId,
  products,
  paymentOption,
) => {
  const orderEntries = [];
  for (const product of products) {
    if (product.quantity !== 0 && !isNaN(product.quantity) && product.kitEntries.length !== 0) {
      const payment = product.paymentOptions.find(
        (value) => value.title === paymentOption.title
      );
      const data = {
        product: {
          id: product.id,
          alias: payment?.alias,
        },
        quantity: product.quantity,
        alias: product.id,
      };
      orderEntries.push(data);
      for (const kitEntry of product.kitEntries) {
        if (kitEntry.product.baseOptions.length !== 0) {
          const baseOptions = kitEntry.product.baseOptions[0];
          for (const option of baseOptions.options) {
            if (option.quantity !== 0 && !isNaN(option.quantity)) {
              const data = {
                product: {
                  id: option.id,
                },
                quantity: option.quantity,
                kitEntryCode: kitEntry.kitEntryCode,
              };
              orderEntries.push(data);
            }
          }
        } else {
          const data = {
            product: {
              id: kitEntry.product.id,
            },
            quantity: kitEntry.configuredQty,
            kitEntryCode: kitEntry.kitEntryCode,
          };
          orderEntries.push(data);
        }
      }
    } else {
      if (product.quantity !== 0 && !isNaN(product.quantity)) {
        const productSelectedPaymentOption = product.paymentOptions.find(
          (prodPayOption) => {
            return (
              prodPayOption.paymentType &&
              prodPayOption.paymentType.key &&
              prodPayOption.paymentType.key === paymentOption.paymentType.key
            );
          },
        );

        const data = {
          product: {
            id: product.id,
            alias:
              productSelectedPaymentOption && productSelectedPaymentOption.alias
                ? productSelectedPaymentOption.alias
                : paymentOption.alias,
          },
          quantity: product.quantity,
        };
        orderEntries.push(data);
      }
    }
  }

  if (orderEntries.length === 0) {
    return { error: [{ th_message: 'กรุณาเลือกสินค้าอย่างน้อย 1 ชิ้น' }] };
  }

  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/item`,
    { cartId, orderEntries },
  );
  return response.data;
};

export const updateCart = async (cartId, itemId, quantity, partnerPromotionId = undefined) => {
  const response = await AxiosPromotion.put(
    `${config.API_URL}/promotion/cart/item`,
    { cartId, itemId, quantity, partnerPromotionId },
  );
  return response?.data?.success ? response?.data?.data : null;
};

export const updateCartPublic = async (cartId, itemId, quantity, guid) => {
  const response = await AxiosPromotion.put(
    `${config.API_URL}/promotion/cart/item/public/${guid}`,
    { cartId, itemId, quantity },
  );
  return response.data.data;
};

export const deleteCartItems = async (
  cartId,
  itemIds,
  isInstallment,
  userId,
  product,
) => {
  const response = await AxiosPromotion.put(
    `${config.API_URL}/promotion/cart/item/delete`,
    { cartId, itemIds, isInstallment, userId, product },
  );
  return response.data.status;
};

export const deleteCartItemsPublic = async (
  cartId,
  itemIds,
  isInstallment,
  userId,
  product,
  guid,
) => {
  const response = await axios.put(
    `${config.API_URL}/promotion/cart/item/delete/public/${guid}`,
    { cartId, itemIds, isInstallment, userId, product }
  );
  return response.data.data;
};

export const updateDeliveryCart = async (
  userId,
  addressId,
  phone,
  cartId,
  isInstallment,
  fullAddress,
) => {
  let onlyUpdateCartPhone = false;

  if ((!addressId && phone) || (addressId && phone)) {
    onlyUpdateCartPhone = true;
  }

  const response = await AxiosPromotion.put(
    `${config.API_URL}/promotion/cart/delivery`,
    {
      addressId,
      selectedId: addressId,
      phone,
      deliveryMode: DELIVERYMODE.HOME,
      cartId,
      isInstallment,
      userId,
      onlyUpdateCartPhone,
      fullAddress
    },
  );
  return response.data;
};

export const updateDeliveryCartPublic = async (
  userId,
  addressId,
  phone,
  cartId,
  isInstallment,
  address,
  guid,
) => {
  const response = await AxiosPromotion.put(
    `${config.API_URL}/promotion/cart/delivery/public/${guid}`,
    {
      addressId,
      selectedId: addressId,
      phone,
      deliveryMode: DELIVERYMODE.HOME,
      cartId,
      isInstallment,
      userId,
      address,
    },
  );
  return response.data;
};

// export const getAddressList = async (userId) => {
//   const response = await axios.get(
//     `${config.API_URL}/promotion/address?uid=${userId}&currentPage=1&perPage=100`
//   );
//   return response.data
// }

//==================COUPONS====================

export const addCouponToCart = async (code, cartId) => {
  const response = await AxiosPromotion.post(
    `${config.API_URL}/promotion/cart/coupons`,
    { code, cartId },
  );
  return response.data;
};

export const deleteCouponToCart = async (code, cartId) => {
  const response = await AxiosPromotion.delete(
    `${config.API_URL}/promotion/cart/${cartId}/coupons/${code}`,
  );
  return response.data;
};

//==================SMART-REPORT====================

export const fetchSmartReport = async (keyword, customer) => {
  try {
    const accessToken = await getAccessToken();
    const { data } = await axios.get(`${config.API_URL}/smart-report`, {
      headers: {
        account: `${customer?.amwayNumber}`,
        customer: `${customer?.partyId}`,
        Authorization: `Bearer ${accessToken}`
      },
      params: { keyword },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getValidateCart = async (aboId, partyId, cartId) => {
  const response = await axios.get(
    `${config.API_URL}/renewal/cart/${partyId}/cartId/${cartId}?validateCart=true`, {
    headers: {
      account: aboId,
      customer: partyId,
    },
  }
  );
  return response?.data?.data;
};

export const getCartId = (isInstallment = INSTALLMENT_TYPE.FALSE) => {
  let cartId = sessionStorage.getItem(SESSION_KEY.pifCartId);
  if (isInstallment === INSTALLMENT_TYPE.TRUE) {
    cartId = sessionStorage.getItem(SESSION_KEY.zippCartId);
  }
  return cartId;
}